var _path, _path2, _line, _line2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCooler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.6667C33 11.953 33 7.89977 33 4.99724C33 3.11346 33 2.17157 32.4142 1.58579C31.8284 1 30.8856 1 29 1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11346 1 4.99724C1 7.89977 1 11.953 1 15.6667M33 15.6667V15.6667C33 17.5523 33 18.4951 32.4142 19.0809C32.4142 19.0809 32.4142 19.0809 32.4142 19.0809C31.8284 19.6667 30.8856 19.6667 29 19.6667V19.6667M33 15.6667C31.6032 15.6667 30.275 15.6667 29 15.6667M1 15.6667V15.6667C1 17.5523 1 18.4951 1.58579 19.0809C1.58579 19.0809 1.58579 19.0809 1.58579 19.0809C2.17157 19.6667 3.11438 19.6667 5 19.6667V19.6667M1 15.6667C2.39682 15.6667 3.72504 15.6667 5 15.6667M5 15.6667V19.6667M5 15.6667C13.8567 15.6667 20.1433 15.6667 29 15.6667M5 19.6667H29M29 15.6667V19.6667",
    stroke: "#12171C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.333 12.5C18.333 12.2239 18.5569 12 18.833 12H19.833C20.1092 12 20.333 12.2239 20.333 12.5C20.333 12.7761 20.1092 13 19.833 13H18.833C18.5569 13 18.333 12.7761 18.333 12.5ZM22.333 12.5C22.333 12.2239 22.5569 12 22.833 12H23.833C24.1091 12 24.333 12.2239 24.333 12.5C24.333 12.7761 24.1091 13 23.833 13H22.833C22.5569 13 22.333 12.7761 22.333 12.5ZM26.833 12C26.5569 12 26.333 12.2239 26.333 12.5C26.333 12.7761 26.5569 13 26.833 13H27.833C28.1091 13 28.333 12.7761 28.333 12.5C28.333 12.2239 28.1091 12 27.833 12H26.833Z",
    fill: "#12171C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.41699,
    y1: 4.25,
    x2: 29.5837,
    y2: 4.25,
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.41699,
    y1: 8.25,
    x2: 29.5837,
    y2: 8.25,
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4628 26.5999C13.6024 27.1817 13.6303 28.5199 12.6254 29.218C11.6205 29.9162 11.9275 30.9635 12.2067 31.3999",
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86221 25C8.00177 25.5818 8.02969 26.92 7.0248 27.6182C6.0199 28.3164 6.32695 29.3636 6.60609 29.8",
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6036 26.5999C21.464 27.1817 21.4361 28.5199 22.441 29.218C23.4459 29.9162 23.1389 30.9635 22.8597 31.3999",
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2032 25C27.0637 25.5818 27.0357 26.92 28.0406 27.6182C29.0455 28.3164 28.7385 29.3636 28.4593 29.8",
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5332 28.2L17.5332 33",
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooler);
export default __webpack_public_path__ + "static/media/cooler.c64e2d808459962ebc8173e2db03da7e.svg";
export { ForwardRef as ReactComponent };